(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* Mango: top level menu parents set to "#" open their submenu on click or tap instead of jumping */
  (() => {
    const SEL = 'header-menu a.menu-list__link[aria-haspopup][href="#"]';
    const closeAll = (except) => {
      document.querySelectorAll(SEL).forEach((link) => {
        if (link === except || link.ariaExpanded !== 'true') return;
        const menu = link.closest('header-menu');
        const li = link.closest('.menu-list__list-item');
        delete link.dataset.mangoPinned;
        if (menu && li && typeof menu.deactivate === 'function') menu.deactivate({ target: li });
      });
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest(SEL);
      if (!link) {
        if (!event.target.closest('header-menu .menu-list__submenu')) closeAll(null);
        return;
      }
      event.preventDefault();
      const menu = link.closest('header-menu');
      const li = link.closest('.menu-list__list-item');
      if (!menu || !li) return;
      if (link.dataset.mangoPinned === 'true' && link.ariaExpanded === 'true') {
        closeAll(null);
        return;
      }
      closeAll(link);
      link.dataset.mangoPinned = 'true';
      if (typeof menu.activate === 'function') menu.activate({ target: li });
    });
    /* Touch and pen fire pointerleave right after a tap, which would close the menu again */
    document.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') return;
      const t = event.target;
      if (!(t instanceof Element) || !t.matches('.menu-list__list-item')) return;
      const link = t.querySelector(':scope > ' + 'a.menu-list__link[data-mango-pinned="true"]');
      if (link) event.stopImmediatePropagation();
    }, true);
    document.addEventListener('pointerenter', (event) => {
      const t = event.target;
      if (event.pointerType === 'mouse' && t instanceof Element && t.matches('.menu-list__list-item')) {
        document.querySelectorAll(SEL + '[data-mango-pinned]').forEach((l) => { if (!t.contains(l)) delete l.dataset.mangoPinned; });
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
